import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c79da14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-lg-500px p-10" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = { class: "text-dark mb-3" }
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = { class: "d-flex flex-stack mb-2" }
const _hoisted_10 = { class: "form-label fw-bold text-dark fs-6 mb-0 required" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "text-center" }

import { ref, onMounted, inject, provide } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import JwtService from "@/core/services/JwtService";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import * as Yup from "yup";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import ApiService from "@/core/services/ApiService";
import i18n from "@/core/plugins/i18n";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import SelectTenantPage from "./signIn/SelectTenantPage.vue";
import ForgetPasswordForm from "./signIn/ForgetPasswordForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UnifiedTwoFaVerificationModal from "@/components/modal/UnifiedTwoFaVerificationModal.vue";

type VerificationMethod = "email" | "sms" | "authenticator";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const pages = ref<any>({
  login: "login",
  selectTenantPage: "SelectTenantPage",
  forgetPasswordPage: "forgetPasswordPage",
});

const { t } = i18n.global;
const te = i18n.global.te;
const router = useRouter();
const store = useStore();
const wsSignalR = inject(TenantGlobalInjectionKeys.WS_SIGNAL_R);
const selectedTenant = ref<any>(null);
const currentPage = ref(pages.value.login);
const tenantsOptions = ref([]);
const formData = ref<any>({});
const isSubmitting = ref(false);
const twoFaRequired = ref(false);
const twoFaCode = ref<any>(null);
const selectedAuthMethod = ref<VerificationMethod | null>(null);
const twoFaModalRef = ref<InstanceType<typeof UnifiedTwoFaVerificationModal>>();
const pendingLoginData = ref<any>(null);
const authTypes = ref<VerificationMethod[]>([]);
const isTwoFaSetupRequired = ref(false);

provide("currentPage", currentPage);
provide("formData", formData);
provide("isSubmitting", isSubmitting);
provide("tenantsOptions", tenantsOptions);
provide("selectedTenant", selectedTenant);
provide("twoFaRequired", twoFaRequired);
provide("twoFaCode", twoFaCode);
provide("pages", pages);

//Create form validation object
const login = Yup.object().shape({
  email: Yup.string().email().required().label("Email"),
  password: Yup.string().min(4).required().label("Password"),
});

const onSubmitLogin = async () => {
  await store.dispatch(Actions.LOGOUT);
  isSubmitting.value = true;
  var errors = null;
  const params = setupLoginParams();

  var login = await ApiService.postToken("connect/token", params).catch(
    ({ response }) => {
      if (response && response.data && response.data.error != undefined) {
        errors = {
          error: response.data.error,
          error_description: response.data.error_description,
        };
      } else {
        errors = response.data.errors;
      }
    }
  );

  if (errors) {
    errorHandle(errors);
    return;
  }

  var breakPoint = false;

  breakPoint = handleMultipleTenants(login);
  if (breakPoint) {
    return;
  }

  breakPoint = handleTwoFA(login);
  if (breakPoint) {
    return;
  }

  await loginStart(login);

  isSubmitting.value = false;
};

function setupLoginParams() {
  const params = new URLSearchParams();
  params.append("client_id", "tenant");
  params.append("grant_type", "password");
  params.append("scopes", "api");
  params.append("username", formData.value.email);
  params.append("password", formData.value.password);
  if (selectedTenant.value !== null) {
    params.append("tenantId", selectedTenant.value);
  }
  if (twoFaRequired.value == true && twoFaCode.value) {
    params.append("code", twoFaCode.value);
    if (selectedAuthMethod.value) {
      params.append("authTypes", selectedAuthMethod.value);
    }
  }
  return params;
}

function errorHandle(errors: any) {
  if (errors && errors.error) {
    const code = errors.error;
    let titleText = code;
    if (te && te("error." + code)) {
      titleText = t("error." + code);
    } else if (typeof code === "string") {
      titleText = code.replace(/_/g, " ").replace(/__/g, "");
    }

    let descText = "";
    if (errors.error_description) {
      if (te && te("error_description." + code)) {
        const m = (errors.error_description || "").match(/(\d+)/);
        const seconds = m ? m[1] : undefined;
        descText = seconds
          ? t("error_description." + code, { seconds })
          : t("error_description." + code);
      } else {
        descText = errors.error_description;
      }
    }

    if (descText) {
      MsgPrompt.error(descText, titleText).then(() => {
        isSubmitting.value = false;
      });
    } else {
      MsgPrompt.error(titleText).then(() => {
        isSubmitting.value = false;
      });
    }
    return;
  }
  if (errors == "__EMAIL_UNCONFIRMED__") {
    if (errors == "__EMAIL_UNCONFIRMED__") {
      currentPage.value = "EmailVerifyPage";
    }
  } else if (errors == "__USER_IS_LOCKED_OUT__") {
    MsgPrompt.error(t("error.__USER_IS_LOCKED_OUT__")).then(() => {
      isSubmitting.value = false;
    });
  } else if (errors == "__USER_UNDER_MAINTENANCE__") {
    MsgPrompt.warning(t("error.__USER_UNDER_MAINTENANCE__")).then(() => {
      isSubmitting.value = false;
    });
  } else if (twoFaRequired.value == true) {
    MsgPrompt.error(t("error.verificationFailed")).then(() => {
      isSubmitting.value = false;
    });
  } else {
    MsgPrompt.error(errors).then(() => {
      isSubmitting.value = false;
    });
  }
}

function isAuthCodeInvalidError(errors: any) {
  if (!errors) return false;

  if (Array.isArray(errors)) {
    return errors.includes("__AUTH_CODE_INVALID__");
  }

  if (typeof errors === "string") {
    return errors.includes("__AUTH_CODE_INVALID__");
  }

  const errorCode = String(errors.error || "").toUpperCase();
  const errorDescription = String(errors.error_description || "").toUpperCase();
  return (
    errorCode.includes("__AUTH_CODE_INVALID__") ||
    errorDescription.includes("__AUTH_CODE_INVALID__")
  );
}

const handleTwoFA = (login: any) => {
  if (
    login?.data?.twoFactorRequired == true ||
    login?.data?.code ||
    login?.data?.authTypes
  ) {
    // 新的 API 响应格式
    if (login?.data?.authTypes && Array.isArray(login.data.authTypes)) {
      authTypes.value = login.data.authTypes;

      // 如果 authTypes 为空数组，要求先设置至少一种2FA
      if (authTypes.value.length === 0) {
        isTwoFaSetupRequired.value = true;
        pendingLoginData.value = login;
        twoFaModalRef.value?.show(
          ["email", "authenticator"],
          formData.value.email,
          [],
          t("tip.pleaseSetupAtLeastOneVerificationMethod")
        );
        return true;
      }

      pendingLoginData.value = login;
      // 不重置 isSubmitting，保持loading状态，防止用户在2FA验证期间重复点击tenant
      // isSubmitting.value = false;

      // 触发统一2FA验证弹窗
      twoFaModalRef.value?.show(
        undefined, // 使用所有可用方法
        formData.value.email,
        authTypes.value
      );
      return true;
    }

    // 旧的 API 响应格式兼容
    twoFaRequired.value = true;
    // 不重置 isSubmitting，保持loading状态
    // isSubmitting.value = false;
    return true;
  }
  return false;
};

// 2FA验证成功回调
const onTwoFaVerified = async (code: string, method: VerificationMethod) => {
  twoFaCode.value = code;
  selectedAuthMethod.value = method;
  twoFaRequired.value = true; // 确保标记为需要2FA
  isTwoFaSetupRequired.value = false;

  // 重新提交登录请求（带上验证码）
  isSubmitting.value = true;
  var errors = null;
  const params = setupLoginParams();

  var login = await ApiService.postToken("connect/token", params).catch(
    ({ response }) => {
      if (response && response.data && response.data.error != undefined) {
        errors = {
          error: response.data.error,
          error_description: response.data.error_description,
        };
      } else {
        errors = response.data.errors;
      }
    }
  );

  if (errors) {
    isSubmitting.value = false;

    if (isAuthCodeInvalidError(errors)) {
      twoFaModalRef.value?.showError(t("tip.invalidCodePleaseTryAgain"));
      return;
    }

    twoFaModalRef.value?.showError(t("error.verificationFailed"));
    errorHandle(errors);
    return;
  }

  // 验证成功，关闭2FA弹窗
  twoFaModalRef.value?.closeModal();

  // 检查是否需要选择租户
  var breakPoint = handleMultipleTenants(login);
  if (breakPoint) {
    return;
  }

  // 登录成功
  await loginStart(login);
  isSubmitting.value = false;
};

// 2FA验证取消回调
const onTwoFaCancel = () => {
  isSubmitting.value = false;
  twoFaCode.value = null;
  selectedAuthMethod.value = null;
  selectedTenant.value = null; // 清空选中的租户，回到登录页面时不带tenantId
  pendingLoginData.value = null;
  isTwoFaSetupRequired.value = false;
};

const handleMultipleTenants = (login: any) => {
  if (login?.data?.hasMultipleTenants == true && selectedTenant.value == null) {
    currentPage.value = "SelectTenantPage";
    tenantsOptions.value = login.data.tenantIds;

    isSubmitting.value = false;
    return true;
  }
  return false;
};

const loginStart = async (login: any) => {
  await store.dispatch(Actions.LOGIN, login.data);
  await storeTenantList();
  wsSignalR?.setup(JwtService.getToken());
  if (router.currentRoute.value.query.redirect) {
    await router.push(router.currentRoute.value.query.redirect as string);
  } else {
    await router.push({ name: "dashboard" });
  }
};

provide("onSubmitLogin", onSubmitLogin);

const storeTenantList = async () => {
  if (selectedTenant.value != null) {
    localStorage.setItem("tenant", selectedTenant.value.toString());
  }
  const res = await TenantGlobalService.getTenantTokens();
  localStorage.setItem("tenantList", JSON.stringify(res));
};

onMounted(() => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (currentPage.value == pages.value.login)
        ? (_openBlock(), _createBlock(_unref(Form), {
            key: 0,
            class: "form w-100",
            id: "kt_login_signin_form",
            onSubmit: onSubmitLogin,
            "validation-schema": _unref(login)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("title.login")), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("fields.email")), 1),
                _createVNode(_unref(Field), {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
                  tabindex: "1",
                  class: "form-control form-control-lg",
                  type: "text",
                  name: "email",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(ErrorMessage), { name: "email" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("fields.password")), 1)
                ]),
                _createVNode(_unref(Field), {
                  modelValue: formData.value.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                  tabindex: "2",
                  class: "form-control form-control-lg",
                  type: "password",
                  name: "password",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(ErrorMessage), { name: "password" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_button, {
                  class: "w-100",
                  size: "large",
                  type: "warning",
                  loading: isSubmitting.value,
                  onClick: onSubmitLogin
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.login")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"]))
        : _createCommentVNode("", true)
    ]),
    (currentPage.value == pages.value.selectTenantPage)
      ? (_openBlock(), _createBlock(SelectTenantPage, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(UnifiedTwoFaVerificationModal, {
      ref_key: "twoFaModalRef",
      ref: twoFaModalRef,
      onVerified: onTwoFaVerified,
      onCancel: onTwoFaCancel
    }, null, 512)
  ], 64))
}
}

})